import { defineQuery } from 'next-sanity'
import { inlineCtaFields } from '../atoms'

export const careersCtaBlockFields = `
  _id,
  _type,
  mainText,
  buttonLink1 {
    ${inlineCtaFields}
  },
  buttonLink2 {
    ${inlineCtaFields}
  },
  buttonLink3 {
    ${inlineCtaFields}
  }
`

export const CAREERS_CTA_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-cta-block"][0]{
    ${careersCtaBlockFields}
  }
`)
